import React from 'react'

const SynthedText = () => {
  return (
    <div>
      <p>
        <b>Synthed</b> is a music education web app made using React, Redux, the Web Audio API, and Spring Boot.
      </p>
      <p>
        It teaches a beginner how to use a synthesiser, with no previous experience or knowledge
        assumed.
      </p>
      <p>
        I completed this project as a part of CodeClan, and have continued to work on it since. I 
        plan to add authentication, more lessons, art assets and improved UI for navigation and 
        lesson indexing.
      </p>
      <p>
        You can check out the code on GitHub or <a href='https://www.synthed.co.uk'>visit the live website</a>. Currently only the front-end
        is hosted but I plan to get the back-end hosted and running soon.
      </p>
    </div>
  )
}

export default SynthedText